export const getFavoritedMessage = (favorited: boolean, numberOfItems = 1, itemName?: string) => {
  let itemCountText = itemName || 'Item';

  if (numberOfItems > 1) {
    itemCountText = `${numberOfItems} items`;
  }
  const action = favorited ? 'added to' : 'removed from';
  return `${itemCountText} ${action} your favorites`;
};
